// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

/**
 * Calculate the bitmask for the the 4 way neighbourhood
 * @param x x position
 * @param y y position
 * @param terrain Terrain array
 * @returns Bitmask
 */
function get4WayBitmask(x: number, y: number, terrain: number[][]): number {
  let total = 0;
  const w = terrain.length;
  const h = terrain[0].length;
  if (x - 1 >= 0 && terrain[x - 1][y] == 1) total += 1;
  if (y - 1 >= 0 && terrain[x][y - 1] == 1) total += 2;
  if (y + 1 < h && terrain[x][y + 1] == 1) total += 4;
  if (x + 1 < w && terrain[x + 1][y] == 1) total += 8;
  return total;
}

/**
 * Calculate the bitmask for the the 8 way neighbourhood
 * @param x x position
 * @param y y position
 * @param terrain Terrain array
 * @returns Bitmask
 */
function get8WayBitmask(x: number, y: number, terrain: number[][]): number {
  let total = 0;
  const w = terrain.length;
  const h = terrain[0].length;
  //Cardinals
  if (y - 1 >= 0 && terrain[x][y - 1] == 1) total += 2;
  if (x - 1 >= 0 && terrain[x - 1][y] == 1) total += 8;
  if (x + 1 < w && terrain[x + 1][y] == 1) total += 16;
  if (y + 1 < h && terrain[x][y + 1] == 1) total += 64;
  //Corners
  if (
    x - 1 >= 0 &&
    y - 1 >= 0 &&
    terrain[x - 1][y - 1] == 1 &&
    terrain[x][y - 1] == 1 &&
    terrain[x - 1][y] == 1
  )
    total += 1;
  if (
    x + 1 < w &&
    y - 1 >= 0 &&
    terrain[x + 1][y - 1] == 1 &&
    terrain[x][y - 1] == 1 &&
    terrain[x + 1][y] == 1
  )
    total += 4;
  if (
    x - 1 >= 0 &&
    y + 1 < h &&
    terrain[x - 1][y + 1] == 1 &&
    terrain[x][y + 1] == 1 &&
    terrain[x - 1][y] == 1
  )
    total += 32;
  if (
    x + 1 < w &&
    y + 1 >= 0 &&
    terrain[x + 1][y + 1] == 1 &&
    terrain[x][y + 1] == 1 &&
    terrain[x + 1][y] == 1
  )
    total += 128;
  return total;
}

export { get4WayBitmask, get8WayBitmask };
